import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../services/api.service';
import {ActivatedRoute, Router} from '@angular/router';
import { Response } from '../../dominio/Response';
import { NgForm } from '@angular/forms';
import {ToastrService} from "ngx-toastr";
import {SessionService} from "../../../core/services/sessionService";

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})

export class LoginComponent implements OnInit {
    password: String;
    usuario: String;

  constructor(private apiService: ApiService,
              private router: Router,
              private activatedRoute: ActivatedRoute,
              private sessionService: SessionService,
              private toastr: ToastrService) {  }

  ngOnInit() {

  }

  validarLogin(myForm: NgForm) {
      if (!myForm.valid) {
          this.toastr.error('Debes completar todos los campos', 'Error!');
      } else {
      this.apiService.post('user', myForm.value).subscribe(	(response: Response) => {
          if (response.error) {
              this.toastr.error(response.data, 'Error!');
          } else {
              this.sessionService.setUsuario(response.data);
              this.sessionService.startSession();
          }
      }, error => {
          this.toastr.error(error.error.data, 'Error!');
      });
      }
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/login/login.component.ts